import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { ContentBox } from '@components/base';
import { AddOrRemoveButton } from '@components/common';
import { Title } from '@models/Title';
import SearchResult from '@modules/search/components/SearchResult';
import SearchToolbar from '@modules/search/components/SearchToolbar';

type TitleSearchProps = {
  currentTitle?: Title;
  disableHeading?: boolean;
  selectedTitle?: Title;
  setSelectedTitle: (title: Title) => void;
};

const TitleSearch: FC<TitleSearchProps> = ({
  currentTitle,
  disableHeading,
  selectedTitle,
  setSelectedTitle,
}) => {
  const { t } = useTranslation();

  return (
    <ContentBox>
      <SearchToolbar disableActions disableHeading={disableHeading} disableSaveSearch />

      <SearchResult
        cardActions={({ simpleTitle, simpleTitle: { masterId } }) =>
          currentTitle && currentTitle.masterId === masterId ? (
            <Typography component='em' variant='caption'>
              Current title
            </Typography>
          ) : selectedTitle && selectedTitle.masterId === masterId ? (
            <AddOrRemoveButton
              icon='remove'
              label={t('deselect')}
              onClick={e => {
                e.stopPropagation();
                setSelectedTitle(simpleTitle);
              }}
              variant='outlined'
            />
          ) : (
            <AddOrRemoveButton
              icon='add'
              label={t('select')}
              onClick={e => {
                e.stopPropagation();
                setSelectedTitle(simpleTitle);
              }}
              variant='contained'
            />
          )
        }
        onSelect={setSelectedTitle}
      />
    </ContentBox>
  );
};

export default TitleSearch;
